import { endpoints } from '@/utils/ApiEndpoints'
import { handle } from '@/utils/ErrorHandling'
import { status } from '@/utils/HttpStatus'

export default {
  methods: {
    login (isLoginAfterSignup) {
      if (isLoginAfterSignup === undefined) isLoginAfterSignup = false

      this.$axios.post(endpoints.user.login, {
        email: this.email,
        password: this.password
      })
        .then(() => {
          if (isLoginAfterSignup) {
            this.$router.push({ name: 'TrangCaNhan' })
          }
          else {
            this.$router.push({ name: 'Home' })
          }
          this.$store.dispatch('setCurrentUser').catch(handle)
        })
        .catch(error => {
          handle(error, {
            [status.HTTP_400_BAD_REQUEST]: () => {
              for (const [field, errorMessages] of Object.entries(error.response.data)) {
                this[field + 'ErrorMessages'] = errorMessages
              }
            },
            [status.HTTP_401_UNAUTHORIZED]: () => {
              this.emailErrorMessages = [error.response.data.detail]
              this.passwordErrorMessages = [error.response.data.detail]
            }
          })
        })
    }
  }
}
